Monitoring.Views ||= {}

class AccountSettings.AssignationLimitSelectorView extends Backbone.View
  template: JST["backbone/templates/account_settings/acd_setting/assignation_limit_selector"]

  events:
    'change select': 'onChange'

  initialize: ({maxLimit, currentLimit = 0}) ->
    @currentLimit = currentLimit
    @maxLimit = maxLimit

  render: =>
    @$el.html(@template(maxLimit: @maxLimit))
    @$el.find("select option[value=#{@currentLimit}]").prop('selected', true)
    @enable() if @currentLimit > 0
    @

  enable: =>
    @_selectEl().removeClass('acd-not-active')
    @_selectEl().prop('disabled', false)

  disable: =>
    @_selectEl().addClass('acd-not-active')
    @_selectEl().prop('disabled', true)

  getAssignationLimit: =>
    parseInt(@_selectEl().val())

  onChange: =>
    @trigger('assignation:limit:change')

  _selectEl: =>
    @$el.find('select')
